import type { User } from '@supabase/supabase-js';

/**
 * Build replacement map for dashboard builder / overlay text.
 * Supports: {first_name}, {last_name}, {full_name}, {email}, {first name} (space variant).
 */
function getDashboardVariableMap(user: User | null): Record<string, string> {
  const full = (user?.user_metadata?.full_name as string) ?? '';
  const parts = full.trim().split(/\s+/);
  const first = parts[0] ?? '';
  const last = parts.length > 1 ? parts.slice(1).join(' ') : '';
  const email = (user?.email as string) ?? '';

  return {
    '{first_name}': first,
    '{last_name}': last,
    '{full_name}': full,
    '{email}': email,
    '{first name}': first,
    '{last name}': last,
    '{full name}': full,
  };
}

/**
 * Replace dashboard variables in text. Use in dashboard builder and overlay when rendering
 * content block labels (header, subheader, text) so e.g. "Hello {first_name}" shows "Hello Theo".
 */
export function replaceDashboardVariables(text: string, user: User | null): string {
  if (!text || typeof text !== 'string') return text;
  const map = getDashboardVariableMap(user);
  let result = text;
  for (const [key, value] of Object.entries(map)) {
    result = result.split(key).join(value);
  }
  return result;
}
